class PredictiveSearch extends HTMLElement {
	constructor() {
		super();

		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelector('#predictive-search');
		this.predictiveSearchDefault = this.querySelector('#predictive-search-default');

		if (!this.input) return;

		this.input.addEventListener(
			'input',
			window.debounce((event) => {
				this.onChange(event);
			}, 300).bind(this)
		);
	}

	onChange() {
		const searchTerm = this.input.value.trim();

		if (!searchTerm.length) {
			this.close();
			return;
		}

		this.getSearchResults(searchTerm);
	}

	getSearchResults(searchTerm) {
		fetch(
			`/search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product,collection&resources[options][fields]=title,product_type,tag,variants.sku,variants.barcode&section_id=predictive-search`
		)
			.then((response) => {
				if (!response.ok) {
					this.close();
					throw new Error(response.status);
				}
				return response.text();
			})
			.then((text) => {
				const doc = new DOMParser().parseFromString(text, 'text/html');
				const section = doc.querySelector('#shopify-section-predictive-search');
				if (!section) return;

				this.predictiveSearchResults.innerHTML = section.innerHTML;
				this._updateSuggestions();
				this.open();
			})
			.catch((error) => {
				this.close();
				throw error;
			});
	}

	_escapeHtml(str) {
		return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}

	_highlightQuery(title, query) {
		const safe = this._escapeHtml(title);
		if (!query) return safe;
		const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		return safe.replace(new RegExp(`(${escaped})`, 'gi'), '<span class="mm-search-highlight">$1</span>');
	}

	_updateSuggestions() {
		const dataEl = this.predictiveSearchResults.querySelector('#mm-predictive-suggestions-data');
		const query = this.input.value.trim();
		let collections = [];
		let articles = [];

		if (dataEl) {
			try {
				const data = JSON.parse(dataEl.textContent);
				collections = data.collections || [];
				articles = data.articles || [];
			} catch (e) {
				window.log('error', 'PredictiveSearch', 'JSON parse failed', { error: e.message });
			}
		}

		window.getElements('[data-search-suggestion-list]').forEach((list) => {
			let html = '';
			collections.forEach((c) => {
				html += `<a href="${this._escapeHtml(c.url)}" class="mm-search-suggestion-item text-sm mm-black-text">${this._highlightQuery(c.title, query)}</a>`;
			});
			articles.forEach((a) => {
				html += `<a href="${this._escapeHtml(a.url)}" class="mm-search-suggestion-item text-sm mm-black-text">${this._highlightQuery(a.title, query)}</a>`;
			});
			list.innerHTML = html;
			const sidebar = list.closest('[data-search-sidebar-suggestions]');
			if (sidebar) {
				sidebar.style.display = (collections.length || articles.length) ? 'flex' : 'none';
			}
		});

		if (window.emit) {
			window.emit('mm:search-suggestions', { collections, articles, query });
		}
	}

	open() {
		this.predictiveSearchResults.style.display = 'block';
		this.predictiveSearchDefault.style.display = 'none';
	}

	close() {
		this.predictiveSearchResults.style.display = 'none';
		this.predictiveSearchDefault.style.display = 'flex';
		document.querySelectorAll('[data-search-sidebar-suggestions]').forEach((s) => {
			s.style.display = 'none';
			const list = s.querySelector('[data-search-suggestion-list]');
			if (list) list.innerHTML = '';
		});
	}

	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}
}

customElements.define('predictive-search', PredictiveSearch);
